var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBigFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#DADFF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m52.493 91.582.111-.05L15.157 10.1l-5.28 2.428 37.447 81.43 5.17-2.377z",
    fill: "#7E8EE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.811 8.634A6.153 6.153 0 0 0 9.65 5.615a6.153 6.153 0 1 0 8.161 3.019z",
    fill: "#7E8EE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.07 8.808a2.75 2.75 0 1 0-4.996 2.298 2.75 2.75 0 0 0 4.997-2.298z",
    fill: "#B5BEEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.126 46.105c8.996.6 17.89 3.05 26.09 7.341-.809-5.963-2.412-12.028-4.83-18.019 5.547-3.306 11.74-6.049 18.486-8.052a95.099 95.099 0 0 0-37.788-10.652c-.648 9.795-1.301 19.589-1.959 29.382z",
    fill: "#465DD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.618 17.683a95.09 95.09 0 0 0-8.534-.96c-.648 9.795-1.301 19.589-1.959 29.382 1.962.13 3.92.35 5.866.655l4.627-29.077z",
    fill: "#465DD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.618 17.683a95.09 95.09 0 0 0-8.534-.96c-.648 9.795-1.301 19.589-1.959 29.382 1.962.13 3.92.35 5.866.655l4.627-29.077z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.187 44.66a67.51 67.51 0 0 0-36.517 5.538c-4.35-9.543-8.698-19.087-13.047-28.63a98.957 98.957 0 0 1 53.534-8.12l-3.97 31.211z",
    fill: "#465DD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.734 7.172 1.642 2.615 2.291-2.069-1.979 2.37 2.676 1.54-2.866-1.15-.637 3.02.209-3.08-3.07.327 2.994-.754-1.26-2.819z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBigFlag);
export default __webpack_public_path__ + "static/media/Icon_Big_Flag.6f29443d.svg";
export { ForwardRef as ReactComponent };